module.exports = __webpack_public_path__ + "static/media/word-document-red.03721abe.svg";